import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { converter } from 'helpers/converter';
import { getApaValdiations } from 'containers/User/components/Form/selector';
import * as constants from './constants';
import InputPhone from '../Inputs/inputPhone';
import InputText from '../Inputs/inputText';

class Phone extends Component {
  state = {
    msisdn: { error: '' },
    otp: { error: '' },
  };

  validPhoneByConfigValidations = phone => {
    const configValidations = getApaValdiations(this.props.metadata);
    const maxLength = _.parseInt(
      _.get(configValidations, 'maxlength_phone_number', 15),
    );
    const minLength = _.parseInt(
      _.get(configValidations, 'minlength_phone_number', 8),
    );
    return phone.length >= minLength && phone.length <= maxLength;
  };

  validOTPByConfigValidations = otp => {
    const configValidations = getApaValdiations(this.props.metadata);
    const maxLength = _.parseInt(_.get(configValidations, 'maxlength_otp', 15));
    const minLength = _.parseInt(_.get(configValidations, 'minlength_otp', 8));
    return otp.length >= minLength && otp.length <= maxLength;
  };

  validatePhone = phone => {
    const msisdn = {};
    const error =
      _.isEmpty(phone) || !this.validPhoneByConfigValidations(phone);
    if (error) {
      msisdn.error = converter.convertApa(
        this.props.translations,
        constants.EMPTY_PHONE,
      );
    }
    this.setState({ msisdn });
    return !error;
  };

  validatePin = () => {
    const { otp } = this.props;
    return !_.isEmpty(otp.value) && this.validOTPByConfigValidations(otp);
  };

  isValid = () => {
    const validatedPhone = this.validatePhone(this.props.msisdn.value);
    const validatedPin = this.validatePin();
    return validatedPhone && validatedPin;
  };

  handleSubmitPhone = e => {
    e.preventDefault();
    const { msisdn } = this.props;
    this.setState({ msisdn: { error: '' }, otp: { error: '' } }, () => {
      if (this.validatePhone(msisdn.value)) {
        const phone = msisdn.value;
        const payload = { phone };
        this.props.onSendPhoneNumber(payload);
      }
    });
  };

  handleSubmitForm = e => {
    e.preventDefault();
    const { msisdn, otp } = this.props;
    this.setState({ msisdn: { error: '' }, otp: { error: '' } }, () => {
      if (this.isValid()) {
        const phone = msisdn.value;
        const pin = otp.value;
        const payload = { phone, pin };
        this.props.onSubmit(payload);
      }
    });
  };

  changeState = e => {
    _.invoke(this.props, 'onChange', e, this.props);
  };

  render() {
    const { translations, login, showPinInput, msisdn, otp } = this.props;

    const labelButton = login
      ? converter.convertApa(translations, constants.LOGIN_BTN_LABEL)
      : converter.convertApa(translations, constants.NEXT_REGISTRY);

    const phonePlace = converter.convertApa(
      translations,
      constants.PHONE_APA_KEY,
    );

    const validatePin = converter.convertApa(
      translations,
      constants.VALIDATEPIN_APA_KEY,
    );

    const configValidations = getApaValdiations(this.props.metadata);
    const maxNumber = _.parseInt(
      _.get(configValidations, 'maxlength_phone_number', '10'),
    );
    const maxPin = _.parseInt(
      _.get(configValidations, 'minlength_phone_number', '10'),
    );

    return (
      <form id="form-telcel" className="form">
        <div className="input-fields">
          <InputPhone
            placeholder={phonePlace}
            name="msisdn"
            changeState={this.changeState}
            value={msisdn.value}
            error={msisdn.error || !!this.state.msisdn.error}
            errorMsg={msisdn.errorMsg || this.state.msisdn.error}
            maxLength={maxNumber}
          />
          {showPinInput && (
            <InputText
              placeholder={validatePin}
              name="otp"
              changeState={this.changeState}
              value={otp.value}
              error={otp.error || !!this.state.otp.error}
              errorMsg={otp.errorMsg || this.state.otp.error}
              maxLength={maxPin}
            />
          )}
        </div>
        <button
          className="btn"
          onClick={
            showPinInput ? this.handleSubmitForm : this.handleSubmitPhone
          }
          type="submit"
        >
          {labelButton}
        </button>
        {showPinInput ? (
          <button
            type="button"
            className="btn-send-code"
            onClick={this.handleSubmitPhone}
          >
            {constants.RESEND_CODE}
          </button>
        ) : null}
      </form>
    );
  }
}

Phone.propTypes = {
  translations: PropTypes.shape({}),
  login: PropTypes.bool,
  showPinInput: PropTypes.bool,
  onSubmit: PropTypes.func,
  onSendPhoneNumber: PropTypes.func,
  metadata: PropTypes.object,
  msisdn: PropTypes.object,
  otp: PropTypes.object,
};

export default Phone;
